// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-drop-area {
    width: 100%;
    height: 150px;
    border: 2px dotted #007bff;
    /* Recuadro punteado azul */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #f8f9fa;
    color: #007bff;
    text-align: center;
    font-size: 1.2em;
    padding: 20px;
    /* Espacio alrededor del texto */
    box-sizing: border-box;
    /* Asegura que el padding no afecte el tamaño */
}

.drag-drop-area:hover {
    background-color: #e9ecef;
    /* Cambio de fondo al pasar el ratón */
}

.drag-drop-area:active {
    background-color: #dfe3e6;
    /* Fondo más claro al hacer clic */
}

.drag-drop-area label {
    margin: 0;
    /* Eliminar márgenes extra del label */
    font-weight: bold;
    /* Poner el texto en negrita */
}`, "",{"version":3,"sources":["webpack://./src/layouts/tables/anexos.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,iBAAiB;IACjB,8BAA8B;AAClC","sourcesContent":[".drag-drop-area {\n    width: 100%;\n    height: 150px;\n    border: 2px dotted #007bff;\n    /* Recuadro punteado azul */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    background-color: #f8f9fa;\n    color: #007bff;\n    text-align: center;\n    font-size: 1.2em;\n    padding: 20px;\n    /* Espacio alrededor del texto */\n    box-sizing: border-box;\n    /* Asegura que el padding no afecte el tamaño */\n}\n\n.drag-drop-area:hover {\n    background-color: #e9ecef;\n    /* Cambio de fondo al pasar el ratón */\n}\n\n.drag-drop-area:active {\n    background-color: #dfe3e6;\n    /* Fondo más claro al hacer clic */\n}\n\n.drag-drop-area label {\n    margin: 0;\n    /* Eliminar márgenes extra del label */\n    font-weight: bold;\n    /* Poner el texto en negrita */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
